import React, { useEffect, useState } from 'react';
import Icons from '../Icons/Icons';
import NamedLink from '../NamedLink/NamedLink';

import css from './Topbar.module.css';

// Closing the bar hides it for this many days (per browser)
const HIDE_DAYS = 3;
const HIDDEN_UNTIL_KEY = 'tm.sellNoteHiddenUntil';

const isHidden = () => {
  try {
    const until = Number(window.localStorage.getItem(HIDDEN_UNTIL_KEY));
    return !!until && until > Date.now();
  } catch (e) {
    return false;
  }
};

/** The green "Have an instrument to sell?" bar above the header, closable for 3 days. */
function SectionTopbarNote(props) {
  const { intl } = props;
  // Rendered on the server; hidden after mount when the visitor closed it recently
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    if (isHidden()) setHidden(true);
  }, []);

  if (hidden) return null;

  const handleClose = () => {
    setHidden(true);
    try {
      window.localStorage.setItem(
        HIDDEN_UNTIL_KEY,
        String(Date.now() + HIDE_DAYS * 24 * 60 * 60 * 1000)
      );
    } catch (e) {
      // Storage blocked: it stays closed until the next page load
    }
  };

  return (
    <div className={css.topbarTop}>
      <div className={css.topbarTopInner}>
        <NamedLink name="NewListingPage" className={css.topbarLink}>
          {intl.formatMessage({ id: 'SectionTopbarNote.sellLabel' })}
          <span className={css.topbarLinkCta}>
            {intl.formatMessage({ id: 'SectionTopbarNote.listItLabel' })}
          </span>
        </NamedLink>
        <button
          type="button"
          className={css.topbarClose}
          onClick={handleClose}
          aria-label={intl.formatMessage({ id: 'SectionTopbarNote.close' })}
        >
          <Icons name="closeIcon" />
        </button>
      </div>
    </div>
  );
}

export default SectionTopbarNote;
